import { persistedStorage } from '@platform/design-system';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type SetupPreferences = {
  readonly trackExpanded: boolean;
  readonly toggleTrack: () => void;
};

const SETUP_PREFERENCES_KEY = 'admin.setup';

export const useSetupPreferences = create<SetupPreferences>()(
  persist(
    (set) => ({
      trackExpanded: true,
      toggleTrack: () => {
        set((state) => ({ trackExpanded: !state.trackExpanded }));
      },
    }),
    {
      name: SETUP_PREFERENCES_KEY,
      storage: persistedStorage(),
      partialize: (state) => ({ trackExpanded: state.trackExpanded }),
      merge: (persisted, current) => {
        const stored = persisted as Partial<SetupPreferences> | undefined;
        return {
          ...current,
          trackExpanded:
            typeof stored?.trackExpanded === 'boolean' ? stored.trackExpanded : current.trackExpanded,
        };
      },
    },
  ),
);
